import { createFileRoute } from "@tanstack/react-router";
import { SamplesPage } from "@/features/harvest-operation-template/samples-page";
import { trpc } from "@/hooks/trpc";

export const Route = createFileRoute(
  "/harvests/operation-templates/$template_id/samples",
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { template_id } = Route.useParams();
  const { data: draft } =
    trpc.harvest.operationTemplates.revisionGetDraftForTemplate.useQuery(
      template_id,
    );
  if (!draft) return null;
  return <SamplesPage templateId={draft.id} />;
}
